import React, {useRef, useState} from "react";
import {
    IonButton,
    IonContent,
    IonHeader, IonIcon, IonItem, IonLabel,
    IonPage, IonRadio, IonRadioGroup,
    IonTitle,
    IonToolbar
} from "@ionic/react";
import './ModalImage.css';
import {warningOutline, warningSharp} from "ionicons/icons";
import {ContactType} from "../types";
import {formatPhone} from "../../../utils";

const ModalImageReplacementRequest = ({dismiss, contact, replacementType}: { dismiss: (data?: string | null | undefined | number, role?: string) => void, contact: ContactType, replacementType: 'PHOTO' | 'AOR_PDF' | 'LEAD_PDF'}) => {


    const modal = useRef<HTMLIonModalElement>(null);
    const [deliveryMethod, setDeliveryMethod] = useState<'SMS' | 'EMAIL' | undefined>(undefined);


    return (
        <IonPage ref={modal}>
            <IonHeader>
                <IonToolbar>

                    <IonTitle>Request Replacement&nbsp;
                        {replacementType === 'PHOTO' &&
                            <>Photo Identification</>
                        }
                        {replacementType === 'AOR_PDF' &&
                            <>Agent of Record Consent</>
                        }
                        {replacementType === 'LEAD_PDF' &&
                            <>Lead Gen Consent</>
                        }
                    </IonTitle>

                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">

                <p>Please select the delivery method the contact would like to receive communication to upload files on:</p>
                <IonRadioGroup onIonChange={(e) => setDeliveryMethod(e.detail.value)}>
                    <IonItem>
                        <IonLabel>SMS to {formatPhone(contact.phone)}</IonLabel>
                        <IonRadio value="SMS"/>
                    </IonItem>
                    <IonItem>
                        <IonLabel>Email to {contact.email}</IonLabel>
                        <IonRadio value="EMAIL"/>
                    </IonItem>
                </IonRadioGroup>



                <p style={{textAlign: 'right'}}>
                    <IonButton fill="solid" color="light" onClick={() => dismiss(null, 'cancel')}>Cancel</IonButton>
                    <IonButton fill="solid" strong={true} onClick={() => dismiss(deliveryMethod, 'confirm')}>
                        Send Request To Contact <IonIcon md={warningOutline} ios={warningSharp}></IonIcon>
                    </IonButton>
                </p>
                <p style={{textAlign: 'right'}}>
                    <span style={{fontSize: '10px', color: '#999999'}}>* Contact will be sent an email or text message upon submission.<br />Text and/or data rates may apply.</span>
                </p>
            </IonContent>
        </IonPage>);
};

export default ModalImageReplacementRequest